import { render } from "./App.vue?vue&type=template&id=74459c8c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=74459c8c&lang=scss"

import exportComponent from "C:\\Users\\wangjiaqi\\Desktop\\txjs.v2.0\\txjs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__